import '../../scss/partials/_global.scss';
import NavigationMenu from '../../extensions/navigation-menu';
import PageManager from './pages/page-manager';
import buildQueryObjects from './common/buildQueryObjects';
import filterGrid from './common/filterGrid';
import toggleButtonGroup from './common/toggleButtonGroup';
import svgInjector from './global/svgInjector';
import miniModalCloseButton from './global/miniModalCloseButton';
import lazyLoad from './global/lazyLoad';
import starRating from './global/starRating';
import magnificInit from './common/magnific';
import toggleIsOpen from './global/toggleIsOpen';
import mediaQueryListFactory from './global/mediaQueryListFactory';
import InstallationPopup from './common/InstallationPopup';
import DeliverLocationPopover from './common/DeliverLocationPopover';

export default class Global extends PageManager {
	constructor(context) {
		super(context);
		this.pageId = this.context.pageId;
		mediaQueryListFactory();
	}

	onReady() {
		if ($('.lazyload').length) {
			window.lazySizesConfig = window.lazySizesConfig || {};
			window.lazySizesConfig.loadMode = 1;
		}
		$('html').removeClass('t-preload');
		buildQueryObjects();
		filterGrid();
		toggleButtonGroup();
		svgInjector();
		miniModalCloseButton();
		lazyLoad();
		starRating();
		magnificInit();
		toggleIsOpen();
		new InstallationPopup();
		new DeliverLocationPopover();

		/**
		 * Initialize the Navigation Menu extension
		 */
		const mainMenuElem = document.querySelector('.js-navigation-menu');
		if (mainMenuElem) {
			new NavigationMenu({
				drawers: '.js-navigation-menu__drawer',
				mainMenu: mainMenuElem,
				mainMenuCloseButtons: '.js-navigation-menu__close',
				mainMenuOpenButtons: '.js-navigation-menu__open',
				menuItems: '.js-navigation-menu__link',
				parentMenus: '.js-navigation-menu__has-child',
				showPreviousMenuButtons: '.js-navigation-menu__previous'
			});
		}
	}
}
